import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { UPDATE_SURGE_COMPAIGN, UPDATE_SURGE_COMPAIGN_SUCCESS, UPDATE_SURGE_COMPAIGN_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateSurgeCompaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${payload?.campaignId}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Campaign updated successfully.`);
      yield put({
        type: UPDATE_SURGE_COMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to update campaign.`;
      cogoToast.error(message);
      yield put({
        type: UPDATE_SURGE_COMPAIGN_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to update campaign.`);
    yield put({ type: UPDATE_SURGE_COMPAIGN_ERROR, payload: error });
  }
}

export function* watchupdateSurgeCompaign() {
  yield takeEvery(UPDATE_SURGE_COMPAIGN, updateSurgeCompaign);
}

function* updateSurgeCompaignSaga() {
  yield all([fork(watchupdateSurgeCompaign)]);
}

export default updateSurgeCompaignSaga;
